export default "__VITE_ASSET__zOalYfzR__"